import { Select, type SelectOption } from "@legal-500/legal500-design-system";
import type { Testimonial } from "../../../../api/pipeline.service";
import styles from "./OrderColumn.module.css";

const MAX_STAFF_DISPLAY_ORDER = 10;

type OrderColumnProps = {
  item: Testimonial;
  canEdit: boolean;
  saving: boolean;
  onChange: (item: Testimonial, displayOrder: number | null) => void;
};

const STAFF_OPTIONS: SelectOption[] = [
  { value: "", label: "–" },
  ...Array.from({ length: MAX_STAFF_DISPLAY_ORDER }, (_, index) => ({
    value: String(index + 1),
    label: String(index + 1),
  })),
];

export function OrderColumn({ item, canEdit, saving, onChange }: OrderColumnProps) {
  const { displayOrder } = item;

  if (!canEdit) {
    return <span className={styles.readOnly}>{displayOrder ?? "–"}</span>;
  }

  const options =
    displayOrder != null && displayOrder > MAX_STAFF_DISPLAY_ORDER
      ? [
          ...STAFF_OPTIONS,
          { value: String(displayOrder), label: `${displayOrder} (set by firm)`, disabled: true },
        ]
      : STAFF_OPTIONS;

  return (
    <div className={styles.orderColumn} onClick={event => event.stopPropagation()}>
      <Select
        size="small"
        className={styles.select}
        aria-label="Display order"
        value={displayOrder == null ? "" : String(displayOrder)}
        options={options}
        disabled={saving}
        onChange={event => {
          const next = event.target.value;
          onChange(item, next === "" ? null : Number(next));
        }}
      />
    </div>
  );
}
